import React, { useEffect, useState } from 'react'
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as eva from 'eva-icons'
import { Link, useParams } from 'react-router-dom'
import { createUsersApi, createEventApi } from '../../utils/api-interface'
import { EventDetailsResponse, UserDetailsResponse } from '../../services/network'
import { EventInfo } from './EventInfo/EventInfo'
import { EventPartecipant } from './EventPartecipant/EventPartecipant'
import { log } from '../../utils/logger'
import './EventDetail.css'
import axios from 'axios'
import { RetryDialog } from '../../components/RetryDialog/RetryDialog'

function EventDetailPage(): JSX.Element {
  const { t } = useTranslation()
  const { userid } = useParams()
  const { eventid } = useParams()
  const [user, setUserProfile] = useState<UserDetailsResponse>()
  const [event, setEvent] = useState<EventDetailsResponse>()
  const [selectedTab, setSelectedTab] = useState(0)
  const [errorData, setErrorData] = useState<any>(null)
  const [isRetryDialogOpen, setIsRetryDialogOpen] = useState(false)
  const handleCloseRetryDialog = (): void => {
    setIsRetryDialogOpen(false)
  }

  useEffect((): void => {
    eva.replace()
  }, [selectedTab])

  const fetchProfile = async (): Promise<void> => {
    if (userid) {
      try {
        const usersApi = createUsersApi()
        const response = await usersApi.getUser(userid)
        setUserProfile(response.data)
      } catch (error) {
        log.error('Error fetching dashboard profile:', error)
      }
    }
  }

  const fetchEvent = async (): Promise<void> => {
    if (eventid) {
      try {
        const usersApi = createEventApi()
        const response = await usersApi.getEventDetails(eventid)
        log.debug(response.data)
        setEvent(response.data)
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error.response) {
            log.error('Error fetching event:', error.response.data)
            setErrorData(error.response.data)
          } else {
            log.error('No response from the server:', error.message)
          }
        } else {
          log.error('Unexpected error:', error)
        }
        setIsRetryDialogOpen(true)
      }
    }
  }
  const handleConfirmRetryDialog = (): void => {
    setIsRetryDialogOpen(false)
    fetchEvent()
  }

  const handleTabChange = (index: number): void => {
    setSelectedTab(index)
  }

  useEffect((): void => {
    fetchProfile()
    fetchEvent()
  }, [])

  return (
    <Flex flexDirection='column' alignItems={'left'} padding={'40px 20px'} gap={'30px'} height={'100%'} overflowY={'auto'}>
      <Breadcrumb spacing='8px' separator={<i data-eva={'chevron-right-outline'} data-eva-fill={'#353F48'}></i>}>
        {userid && (
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to='/users'>
              <Text fontSize='16px' fontWeight='400' lineHeight='22.4px'>
                {t('users.title')}
              </Text>
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
        {eventid && !userid && (
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to='/events'>
              <Text fontSize='16px' fontWeight='400' lineHeight='22.4px'>
                {t('events')}
              </Text>
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
        {userid && (
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to={`/users/userinfo/${userid}`}>
              <Text fontSize='16px' fontWeight='400' lineHeight='24px'>
                {user?.firstName} {user?.lastName}
              </Text>
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
        <BreadcrumbItem>
          <BreadcrumbLink>
            <Text fontSize='16px' fontWeight='700' lineHeight='24px'>
              {event?.eventName.substring(0, 45).concat(event?.eventName.length > 45 ? '...' : '')}
            </Text>
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Text fontSize='26px' fontWeight='700' lineHeight='31.2px' textAlign='left'>
        {t('event_tab')}
      </Text>
      <Tabs variant={'primary'} onChange={(index): void => handleTabChange(index)}>
        <TabList>
          <Tab className={selectedTab === 0 ? 'eventpage-tab-selected' : 'eventpage-tab'}>
            <Flex direction={'column'} alignItems={'center'} gap={'4px'}>
              <i data-eva={'edit-2-outline'} className='eva-icon'></i>
              <Text fontSize='14px' fontWeight='700' lineHeight='16px'>
                {t('info')}
              </Text>
            </Flex>
          </Tab>
          <Tab className={selectedTab === 1 ? 'eventpage-tab-selected' : 'eventpage-tab'}>
            <Flex direction={'column'} alignItems={'center'} gap={'4px'}>
              <i data-eva={'calendar-outline'} className='eva-icon'></i>
              <Text fontSize='14px' fontWeight='700' lineHeight='16px'>
                {t('inscribed')}
              </Text>
            </Flex>
          </Tab>
        </TabList>
        <TabPanels overflow={'auto'}>
          <TabPanel>{event ? <EventInfo event={event} /> : <></>}</TabPanel>
          <TabPanel>
            <EventPartecipant />
          </TabPanel>
        </TabPanels>
      </Tabs>
      <RetryDialog isOpen={isRetryDialogOpen} onClose={handleCloseRetryDialog} onConfirm={handleConfirmRetryDialog} message={errorData} />
    </Flex>
  )
}

export { EventDetailPage }
